import React from "react";
import { IconButton } from "@chakra-ui/react";

import { pxToRem } from "../../../utils/styles/size";
import { hexToRgba } from "../../../utils/styles/color";
import AddIcon from "../../atom/icons/AddIcon";
import Tooltip from "../../atom/Tooltip";

interface SideBarSpaceAddButtonProps {
  onClick: () => void;
}
export const SideBarSpaceAddButton: React.FC<SideBarSpaceAddButtonProps> = ({ onClick }) => {
  return (
    <Tooltip
      content={"Add a space"}
      side={"right"}
      className="origin-left"
    >
      <IconButton
        icon={
          <AddIcon
            color={"#cacdce"}
            _groupHover={{
              color: "white",
            }}
          />
        }
        role={"group"}
        aria-label={"Add Space"}
        onClick={onClick}
        variant="outline"
        fontSize={pxToRem(18)}
        borderRadius={pxToRem(5)}
        border={"none"}
        minWidth={"initial"}
        mx={pxToRem(2)}
        boxSize={pxToRem(28)}
        _hover={{
          bg: hexToRgba("#ffffff", 0.08),
        }}
        _focus={{
          outline: "none",
          boxShadow: "none",
        }}
        _active={{}}
      />
    </Tooltip>
  );
};
